import { ReactNode, Suspense } from 'react';
import { HeadingWithBreadcrumbs } from './HeadingWithBreadCrumps';
import { TopNav } from './TopNav';
import { NavLink, Outlet, useLocation } from 'react-router';

export const SingleBreadcrumb = ({
  to,
  children,
}: {
  to: string;
  children: ReactNode;
}) => {
  return (
    <li>
      <div className="flex">
        <NavLink
          to={to}
          className="text-sm font-medium text-gray-500 hover:text-gray-700"
        >
          <>{children}</>
        </NavLink>
      </div>
    </li>
  );
};
export const DefaultBreadcrumb = () => (
  <SingleBreadcrumb to={'/'}>Dashboard</SingleBreadcrumb>
);

export function PageHeading({ children }: { children: React.ReactNode }) {
  return (
    <div className="primary mt-5 pt-2">
      <HeadingWithBreadcrumbs title={children} />
    </div>
  );
}

export function PageBody({ children }: { children: React.ReactNode }) {
  return (
    <div className="primary">
      <div className="my-6">{children}</div>
    </div>
  );
}

export function AppLayout() {
  const isNotRootRoute = useLocation().pathname !== '/';
  return (
    <div className="text-gray-900">
      {isNotRootRoute && <meta name="robots" content="noindex, follow" />}
      <TopNav />
      <Suspense fallback={<div>Loading...</div>}>
        <Outlet />
      </Suspense>
    </div>
  );
}
